import styled from '@emotion/styled';
import { Box } from '@mafc/trolly';
import COLORS from 'theme/colors';

export const NowMessageBox = styled(Box)`
  display: block;
  padding: 18px 16px;
  display: flex;
  justify-content: inherit;
  flex-direction: row;
  background-color: ${COLORS.LIGHT_BLUE};
  align-items: center;
  margin-bottom: 16px;
  border-radius: 8px;
`;
export const NowMessageBoxText = styled(Box)`
  padding-left: 12px;
  div:nth-child(1) {
    font-size: 12px;
  }
  div:nth-child(2) {
    font-size: 8px;
    padding-top: 2px;
  }
`;

export const DeliveryText = styled(Box)`
  padding-left: 10px;
  div {
    font-size: 14px;
  }
`;
